import React from 'react';

interface PartnerHeaderProps {
  partner: any;
  onBack: () => void;
}

const PartnerHeader: React.FC<PartnerHeaderProps> = ({ partner, onBack }) => {
  if (!partner) return null;

  return (
    <div className="border-b pb-4 mb-4">
      <div className="flex items-center justify-between gap-4">
        <h2 className="text-2xl font-bold text-gray-800">
          {partner.name}
        </h2>

        <button
          type="button"
          onClick={onBack}
          className="px-3 py-1 text-base font-semibold text-blue-600 hover:text-blue-800"
        >
          ← Back
        </button>
      </div>

      <div className="mt-2 flex flex-wrap gap-6 text-sm text-gray-600">
        <span>
          <strong>Mobile:</strong> {partner.mobile || '-'}
        </span>

        <span>
          <strong>Profession:</strong> {partner.profession || '-'}
        </span>

        <span>
          <strong>Status:</strong>{' '}
          <span className="capitalize">
            {partner.status || '-'}
          </span>
        </span>
      </div>
    </div>
  );
};

export default PartnerHeader;
